import {
  Component,
  OnInit,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { ToastService } from './services/toast-service';
import { SpinnerService } from './services/spinner.service';
import { Language, TranslateService } from '@ngx-translate/core';
import localeDa from '@angular/common/locales/da';
import localeEn from '@angular/common/locales/en';
import { TimeService } from './services/time.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [
    RouterModule,
    SpinnerComponent
  ],
})
export class AppComponent implements OnInit {
  private readonly LANGUAGE_PREFERENCE_KEY = 'rejsebillet_lang';

  constructor(
    private translateService: TranslateService,
    private timeService: TimeService
  ) {
  }

  ngOnInit(): void {
    this.timeService.getServerTime().subscribe({
      next: () => { },
      error: err => console.error('Failed to load server time', err),
    });
    this.initializeLanguage();
    registerLocaleData(localeDa, 'da');
    registerLocaleData(localeEn, 'en');
  }

  initializeLanguage(): void {
    const supportedLanguages = ['en', 'da'];
    const defaultLanguage = 'en';

    this.translateService.addLangs(supportedLanguages);

    const browserLang = this.translateService.getBrowserLang();
    const fallbackLang = (browserLang && supportedLanguages.includes(browserLang))
      ? browserLang
      : defaultLanguage;

    const language = this.loadLanguagePreference() || fallbackLang;
    this.translateService.use(language);
  }

  loadLanguagePreference(): Language | null {
    try {
      return localStorage.getItem(this.LANGUAGE_PREFERENCE_KEY) as Language;
    } catch {
      return null;
    }
  }
}
